module.exports = __webpack_public_path__ + "static/media/alignment_output_data.16d68e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/alignment_output_data.png
// module id = 2351
// module chunks = 0